import { getRouterPaths } from "./routerPaths";

export const ROUTE_TITLES = (role, company_name) => {
  const routerPaths = getRouterPaths(role);

  return {
    [routerPaths.home]: `Benvenuto ${role === "Admin" ? role : company_name}`,
    [routerPaths.lands]: "Lista terreni",
    [routerPaths.users]: "Lista utenti",
    [routerPaths.fieldsType]: "Tipologia Terreni",
    [routerPaths.settings]: "Impostazioni",
    [routerPaths.profile]: "Profilo",
    [routerPaths.userLands]: "I miei terreni",
    [routerPaths.cultureList]: "Lista Colture",
    [routerPaths.irrigationType]: "Tipologia Irrigazione",
    [routerPaths.tools]: "I miei strumenti",
    [routerPaths.fieldNotebook]: "Taccuino di campo",
    [routerPaths.toolRequest]: "Richiesta di aggiunta strumento",
  };
};

export const SPECIAL_ROUTES = (role, company_name, fieldName, instrument) => {
  const routerPaths = getRouterPaths(role);

  const landsPath =
    role === "Admin" ? routerPaths.lands : routerPaths.userLands;
  const landsTitle = role === "Admin" ? "Lista terreni" : "I miei terreni";

  return {
    [routerPaths.addUsers]: [
      { path: routerPaths.users, title: "Lista utenti" },
      { path: routerPaths.addUsers, title: "Nuovo utente" },
    ],
    [routerPaths.addCulture]: [
      { path: routerPaths.cultureList, title: "Lista Colture" },
      { path: routerPaths.addCulture, title: "Nuova coltura" },
    ],
    [routerPaths.addFieldType]: [
      { path: routerPaths.fieldsType, title: "Tipologia Terreni" },
      { path: routerPaths.addFieldType, title: "Nuova tipologia" },
    ],
    [routerPaths.updateCulture + "/:id"]: [
      { path: routerPaths.cultureList, title: "Lista Colture" },
      { path: routerPaths.updateCulture, title: "Aggiorna coltura" },
    ],
    [routerPaths.updateUser + "/:id"]: [
      { path: routerPaths.users, title: "Lista utenti" },
      { path: routerPaths.updateUser, title: company_name },
    ],
    [routerPaths.addIrrigation]: [
      { path: routerPaths.irrigationType, title: "Tipologia irrigazione" },
      { path: routerPaths.addIrrigation, title: "Nuova irrigazione" },
    ],
    [routerPaths.updateIrrigation + "/:id"]: [
      { path: routerPaths.irrigationType, title: "Tipologia irrigazione" },
      { path: routerPaths.updateIrrigation, title: "Aggiorna irrigazione" },
    ],
    [routerPaths.updateFieldType + "/:id"]: [
      { path: routerPaths.fieldsType, title: "Tipologia Terreni" },
      {
        path: routerPaths.updateFieldType,
        title: "Aggiorna tipologia terreno",
      },
    ],
    [routerPaths.addField]: [
      { path: routerPaths.userLands, title: "I miei terreni" },
      { path: routerPaths.addField, title: "Nuovo terreno" },
    ],
    [routerPaths.field + "/:id"]: [
      { path: routerPaths.userLands, title: "I miei terreni" },
      { path: routerPaths.field, title: fieldName },
    ],
    [routerPaths.updateField + "/:id"]: [
      { path: landsPath, title: landsTitle },
      { path: routerPaths.updateField, title: "Aggiorna terreno" },
    ],
    [routerPaths.addTool]: [
      { path: routerPaths.tools, title: "I miei strumenti" },
      { path: routerPaths.addTool, title: "Nuovo strumento" },
    ],
    [routerPaths.updateTool + "/:id"]: [
      { path: routerPaths.tools, title: "I miei strumenti" },
      {
        path: routerPaths.updateTool,
        title: `Aggiorna ${instrument ? instrument : "strumento"}`,
      },
    ],
    [routerPaths.addNote]: [
      { path: routerPaths.fieldNotebook, title: "Taccuino di campo" },
      { path: routerPaths.addNote, title: "Nuova nota" },
    ],
    [routerPaths.digitalTwin]: [
      { path: routerPaths.digitalTwin, title: "Digital Twin" },
    ],
    [routerPaths.cropDetail + "/:id"]: [
      { path: routerPaths.cropDetail, title: "Dettaglio coltura" },
    ],
  };
};

export const routePermissions = {
  Admin: [
    "/admin/home",
    "/admin/users",
    "/admin/users/addUser",
    "/admin/lands",
    "/admin/fieldsType",
    "/admin/settings",
    "/admin/cultureList",
    "/admin/irrigationType",
    "/admin/cultureList/addCulture",
    "/admin/cultureList/updateCulture/:id",
    "/admin/users/updateUser/:id",
    "/admin/irrigationType/addIrrigation",
    "/admin/irrigationType/updateIrrigation/:id",
    "/admin/fieldsType/addFieldType",
    "/admin/fieldsType/updateFieldType/:id",
    "/admin/lands/updateField/:id",
    "/monitoring",
  ],
  Customer: [
    "/home",
    "/userLands",
    "/profile",
    "/settings",
    "/userLands/addField",
    "/userLands/:id",
    "/userLands/updateField/:id",
    "/tools",
    "/tools/addTool",
    "/fieldNotebook",
    "/tools/updateTool/:id",
    "/toolRequest",
    "/fieldNotebook/addNote",
    "/monitoring",
    "/digitalTwin",
    "/digitalTwin/:id",
    "/digitalTwin/livestock/:id",
  ],
};
